import type { GymEquipment } from "../types/garage";

const NOW = "2026-07-31T10:15:00.000Z";

export const gymEquipment: GymEquipment[] = [
  {
    id: "gym-kettlebell-set",
    category: "gym",
    lifecycleStatus: "active",
    readinessStatus: "ready",
    archived: false,
    notes: "Includes 16kg and 24kg bells.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    name: "Kettlebell Set",
    gymCategory: "strength",
    quantity: 2
  },
  {
    id: "gym-yoga-mat",
    category: "gym",
    lifecycleStatus: "active",
    readinessStatus: "ready",
    archived: false,
    notes: "Mobility and breathing work.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    name: "Yoga Mat",
    gymCategory: "mobility",
    quantity: 1
  }
];
